import { IOnboardingStepProps } from "../Onboarding";

import { View } from "./View";

export const OnboardingTwo = (props: IOnboardingStepProps) => {
  return <View onSubmit={props.handleNext} {...props} />;
};
